import {CSSProperties, FC} from 'react';


export interface IIconSeatBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSeatBmw: FC<IIconSeatBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M17.281 4h1.313C19.369 4 20 4.63 20 5.406V6.72c0 .775-.63 1.406-1.406 1.406H17.28c-.775 0-1.406-.63-1.406-1.406V5.406c0-.775.63-1.406 1.406-1.406Zm1.313 5.062H17.28a2.335 2.335 0 0 1-1.635-.666l-.014.04-2.289 6.495-1.612-.12-1.008-.074-1.466-.108-.976-.072-1.474-.11-.568-.041a1.986 1.986 0 0 0-.258-.007l-.032-.002-.095.006A2.034 2.034 0 0 0 4 16.427V20h13.4l1.683-10.488a1.82 1.82 0 0 0 .077-.52 2.34 2.34 0 0 1-.566.07Z" clipRule="evenodd" />
        </svg>
    );
};
